import classNames from "classnames";
import { useState } from "react";
import { MdChevronRight } from "react-icons/md";
import { API } from "../../services/api/types";
import { humanizeDate } from "../../utils/date";
import OddsAdvertisement from "../OddsAdvertisement";

type GamesProps = {
  title?: string;
  games: API.Game[];
  campaign?: API.Campaign;
};

const Games = (props: GamesProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-black-lightest">
      {props.title && (
        <div className="bg-green text-white text-xs p-1 inline-block m-4">
          {props.title}
        </div>
      )}

      <div className="divide-y divide-black-lightest-hover">
        {props.games.slice(0, isExpanded ? 5 : 1).map((game, index) => {
          const [homeTeam, awayTeam] = game.name.split(" - ");

          return (
            <>
              <div className={classNames("mx-4 py-2")}>
                <div className="flex justify-between items-center">
                  <div>
                    <div className="text-sm">
                      {humanizeDate(game.start_date)}
                    </div>
                    <div>{homeTeam}</div>
                    <div>{awayTeam}</div>
                  </div>

                  <div className="flex space-x-2">
                    {(game.odds || "")?.split(",")?.map((data, index) => (
                      <div
                        key={`${game.id}-odds-${index}`}
                        className="text-sm text-center"
                      >
                        <div>
                          {index === 0 && "1"}
                          {index === 1 && "X"}
                          {index === 2 && "2"}
                        </div>
                        <div className="font-bold">{data}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {index === 0 && props.campaign && (
                <div className={classNames("mx-4 pt-2 pb-5 mb-3")}>
                  <OddsAdvertisement
                    url={props.campaign.link}
                    image={props.campaign.image}
                    impression={props.campaign.impression}
                    showDisclaimer
                    text={
                      <div className="mx-2">
                        <div className="font-bold">
                          {props.campaign.content}
                        </div>
                        <div className="text-xs">
                          {props.campaign.disclaimer}
                        </div>
                      </div>
                    }
                  />
                </div>
              )}
            </>
          );
        })}
      </div>

      {props.games.length > 1 && (
        <button
          className="font-bold w-full p-4 pt-0 flex justify-center items-center text-sm"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <span>{isExpanded ? "Visa mindre" : "Visa mer"}</span>
          <MdChevronRight
            size={20}
            className={classNames("rotate-90", {
              "-rotate-90": isExpanded,
            })}
          />
        </button>
      )}
    </div>
  );
};

export default Games;
